export default {
  openIndexedDB(version) {
    return new Promise((resolve, reject) => {
      // indexedDB兼容
      let indexedDB =
        window.indexedDB ||
        window.webkitindexedDB ||
        window.msIndexedDB ||
        mozIndexedDB;
      if (!indexedDB) {
        console.log("你的浏览器不支持IndexedDB");
        return;
      }
      // console.log(indexedDB);
      let ver = version || 4;
      console.log("数据库版本", ver);
      let request = indexedDB.open("myDB", ver);
      // 如果指定的版本号，大于数据库的实际版本号，就会发生数据库升级事件upgradeneeded。
      // 升级后自动触发success
      // 第一次打开成功后或者版本有变化自动执行以下事件：一般用于初始化数据库。
      request.onupgradeneeded = (e) => {
        console.log("初始化或版本变动");
        let db = e.target.result; // 获取到 demoDB对应的 IDBDatabase实例,也就是我们的数据库。
        // 会话表（多个会话）
        this.createTable(e, "conversation", [
          "type", // 会话类型  homeChat , new, ....(自定义) 
          "class", // 分类 home(首页), new(新建AI聊天), create(创作), specific(专家)
          "title", // 会话名称 
          "keyword", //会话的关键字
          "question", //会话的第一条问题
          "answer", //会话的第一个回答
          "createTime", //创建时间
          "updateTime", //更新时间
        ]);
        //问答表(会话详细，多个问答)
        this.createTable(e, "conversation_detail", [
          "conversationId",
          "type", // 类型  同conversation表 
          "keyword", //问答的关键字 同conversation表 同一个 conversationId 的问答只有第一条数据可能有keyword
          "question", //问题
          "answer", //单条问答的第一个回答
          "createTime", //创建时间
          "updateTime", //更新时间
        ]);
        //单个问答回复数据表
        this.createTable(e, "chat", [
          "conversationDetailId",
          "type", //类型
          "status", // 状态
          "title", //
          "question", //问题
          "answer", //回答
          "createTime", //创建时间
          "updateTime", //更新时间
        ]);
        // this.createTable(e, "chat_table_v2", [
        //   "title",
        //   "icon",
        //   "question",
        //   "answer",
        //   "typeName",
        //   "type",
        //   "createTime",
        //   "updateTime",
        //   "key1",
        //   "key2",
        //   "key3",
        //   "key4",
        // ]);
        // this.createTable(e, "conversation_table_v2", [
        //   "title",
        //   "icon",
        //   "question",
        //   "keyword",
        //   "answer",
        //   "typeName",
        //   "type",
        //   "createTime",
        //   "updateTime",
        //   "key1",
        //   "key2",
        //   "key3",
        //   "key4",
        // ]);
        // this.createTable(e, "conversation_detail_table_v2", [
        //   "conversationId",
        //   "title",
        //   "test",
        //   "icon",
        //   "question",
        //   "keyword",
        //   "answer",
        //   "typeName",
        //   "type",
        //   "createTime",
        //   "updateTime",
        //   "key1",
        //   "key2",
        //   "key3",
        //   "key4",
        // ]);
        // this.createTable(e, "specific_table_v2", [
        //   "title",
        //   "icon",
        //   "typeName",
        //   "question",
        //   "type",
        //   "answer",
        //   "createTime",
        //   "updateTime",
        //   "key1",
        //   "key2",
        //   "key3",
        //   "key4",
        // ]);
        console.log("数据库版本更改为： " + db.version);
        // resolve(db)
      };
      // success
      request.onsuccess = (event) => {
        let db = event.target.result;
        // console.log("数据库打开/创建成功", event, db.version);
        resolve(db);
      };
      request.onversionchange = (event) => {
        let db = event.target.result;
        // console.log("数据库打开/创建成功1", event, db.version);
        resolve(db);
      };
      // err
      request.onerror = (event) => {
        console.log("数据库打开/创建报错", event);
      };
    });
  },
  createTable(e, tableName, keys) {
    let db = e.target.result
    let objectStore
    if (!db.objectStoreNames.contains(tableName)) {
      //如果表格不存在，创建一个新的表格（keyPath，主键 ； autoIncrement,是否自增），会返回一个对象（objectStore）
      // objectStore就相当于数据库中的一张表。IDBObjectStore类型。
      objectStore = db.createObjectStore(tableName, {
        keyPath: "id",
        autoIncrement: true, //自动生成主键
      });
      console.log("创建表: " + tableName + " 成功");
    } else {
      objectStore = e.target.transaction.objectStore(tableName)
      console.log("更新表: " + tableName + " 成功");
    }
    //指定可以被索引的字段，unique字段是否唯一。类型： IDBIndex
    keys.forEach((key) => {
      if (!objectStore.indexNames.contains(key)) {
        objectStore.createIndex(key, key, {
          unique: false, //是否唯一
        });
      }
    });
    
  },
  closeDB(db) {
    db.close();
    // console.log("数据库已关闭");
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/indexedDB.js